<template>
  <DefaultDeleteModal
    title="Remover legenda"
    hookSufix="RemoveSubtitle"
    :isLoading="isLoading"
    :alertMessage="alertMessage"
    @confirmDelete="$emit('confirmDelete')"
  />
</template>

<script>
import DefaultDeleteModal from '@/components/AddSubtitleModal/DefaultDeleteModal.vue'

export default {
  name: 'RemoveSubtitleModal',
  components: {
    DefaultDeleteModal,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    alertMessage: `Tenha em mente que, ao apagar uma legenda do seu vídeo, todo o texto
            desta legenda associado a ele
            <b>será perdido</b>. Certifique-se de que esta é a ação que você
            deseja realizar.`,
  }),
}
</script>
